import { MainFooter, MobileSidebar, BaseSelect, StatisticCard } from '@bt/design-system'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('MainFooter', MainFooter)
  nuxtApp.vueApp.component('MobileSidebar', MobileSidebar)
  nuxtApp.vueApp.component('BaseSelect', BaseSelect)
  nuxtApp.vueApp.component('StatisticCard', StatisticCard)
})
